import React from "react";

function PlusIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <rect width="20" height="20"  rx="2"></rect>
      <path
        stroke="#000"
        strokeWidth="1.5"
        d="M10 3v13.5M3.25 9.75h13.5"
      ></path>
    </svg>
  );
}

export default PlusIcon;
